import './voy-timeseries-chart-tooltip';
import { VoyTimeseriesChartTooltip } from './voy-timeseries-chart-tooltip';
import { GetUTCTimestamp } from '../../../src/utils/helpers';

// Note: These echarts type are only partial, extend if needed
export interface DataSeriesEntry
{
    name?: string;
    type?: string;
    step?: string;
    color?: string;
    showSymbol?: boolean;
    symbol?: string;
    hoverAnimation?: boolean;
    data?: [number,number|null][];
    animation?: boolean;
    markLine?: {
        symbol: string|string[];
        symbolOffset?: number[]|string[];
        data: any;
    };
    areaStyle?: {[index:string]: any};
    lineStyle?: {[index:string]: any};
    stack?: string;
    markArea?: {[index:string]: any};
    markPoint?: {[index:string]: any};
    grid?: {[index:string]: any},
    xAxis?: {[index:string]: any}[];
    yAxis?: {[index:string]: any}[];
    series?: {[index:string]: any}[];
    dataZoom?: {[index:string]: any}[];
    zlevel: number;
    tooltip?: {[index:string]: any};
    xAxisIndex?: number;
    dataset?: {[index:string]: any}
    useUTC?:boolean
}


export interface TooltipFormatterParams
{
    seriesType: string;
    seriesIndex: number;
    seriesName: string;
    name: string;
    dataIndex: number;
    value: [number,number];
    dimensionNames: string[];
    dimensionIndex: number;
    color: string;
    directionValue?: number;
    data?: number[];
}

export enum TimeseriesChartTimeFormat {
    Hours = "hours",
    DayAndMonth = 'DayAndMonth'
}

export interface YAxisChartParams {
    nameRotate: number;
    nameLocation: string;
    padding: number | number[];
    nameGap: number;
    max?: number | string | ((value: { min: number; max: number }) => number);
}

export interface TooltipPosition {
    top: number;
    [key: string]: number;
}

export function dateFormatter(value: number, timeFormat: TimeseriesChartTimeFormat,) {
    let date = new Date(value);
    if (TimeseriesChartTimeFormat.Hours === timeFormat) {
        return GetUTCTimestamp(value)
    }
    // day and month
    const month = date.toLocaleString('en-us', { month: 'short', timeZone: 'UTC' });
    return `${date.getUTCDate()} ${month}`;
}
export class EchartsOptions
{
    static options(dataSeries: DataSeriesEntry[], textColor: string, unit: string,  leftPadding: number,  timeFormat: TimeseriesChartTimeFormat, yAxisChartParams?: YAxisChartParams, tooltip?: DataSeriesEntry["tooltip"])
    {
        const tooltipElement = new VoyTimeseriesChartTooltip();
        tooltipElement.unit = unit;

        return {
            useUTC: true,
            title: {
                text: '',
            },
            textStyle: {
                color: textColor,
                fontSize: 12,
                fontFamily: 'MaerskText'
            },
            grid: {
                top: 35,
                bottom: 35,
                right: 20,
                left: leftPadding,
            },
            tooltip: tooltip,
            dataZoom: [{
                type: 'inside',
            }, {
                type: 'slider',
                brushSelect: false,
                showDetail: false,
                height: 24,
            }],
            xAxis: [
                {
                    type: 'time',
                    axisPointer: {show:true},
                    axisLabel: {
                        formatter: (value: number) => {
                            return dateFormatter(value, timeFormat)
                        }
                    },
                    splitNumber: 3,
                    maximum: 500
                },
            ],
            yAxis: {
                nameRotate: 0,
                nameLocation: 'end',
                nameTextStyle: {
                    color: textColor,
                    fontSize: 10,
                    fontFamily: 'MaerskText',
                    padding: yAxisChartParams ? yAxisChartParams.padding : [0, 0, 0, 0],
                    align: "center"
                },
                min: 'dataMin',
                max: yAxisChartParams?.max !== undefined ? yAxisChartParams.max : (value: { min: number; max: number }) => {
                    // Add ~15% padding above the max value
                    const range = value.max - value.min;
                    return value.max + (range * 0.15);
                },
                axisLabel: {
                    showMinLabel: false,
                    showMaxLabel: false
                },
                name: unit,
                nameGap: 10
            },
            responsive: true,
            maintainAspectRatio: false,
            series: dataSeries
        }
    }
}
